import DigitalColorBlock from "../../screens/logo-editor/componenets/DigitalColorBlock";
import Tooltip from "@mui/material/Tooltip";

interface DigitalColorElementProps {
  showText?: boolean;
  text?: string;
}

export function DigitalColorElement({
  showText = true,
  text = "Digital",
}: DigitalColorElementProps) {
  const content = (
    <div className={"flex items-center space-x-1"}>
      <DigitalColorBlock size={"sm"} />
      {showText && <p>{text}</p>}
    </div>
  );

  if (!showText) {
    return (
      <Tooltip title={text} placement={"right"}>
        {content}
      </Tooltip>
    );
  }

  return content;
}
